module.exports = __webpack_public_path__ + "static/media/fansided.7e854a5e.jpg";